import { initializeApp } from "@firebase/app";
import { getDatabase, onValue, ref, set } from "@firebase/database";
import { Button, Card, CardContent, FormControl, Grid, InputLabel, MenuItem, Select, Autocomplete, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, useMediaQuery } from "@mui/material";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DownloadIcon from '@mui/icons-material/Download';
import { useParams } from "react-router"
import Quote from "./Quote";
import i18n from "./18n";

const firebaseConfig = {
    apiKey: "AIzaSyA8TopHMkPlDZRaKUv7bpaMnnYgfHDxMc4",
    authDomain: "lybra-pricing.firebaseapp.com",
    projectId: "lybra-pricing",
    storageBucket: "lybra-pricing.appspot.com",
    messagingSenderId: "127223574332",
    appId: "1:127223574332:web:4cea6a20e9c27603a4f839",
    measurementId: "G-NFK626DC0R",
    databaseURL: "https://lybra-pricing-default-rtdb.europe-west1.firebasedatabase.app/"
};
  
const currencyMap = {
    'USD': '$',
    'EUR': '€'
}

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export default function ViewQuote () {

    const { t } = useTranslation()

    const { sales, id } = useParams()

    const [quote, setQuote] = useState()
    const [user, setUser] = useState()
    const [name, setName] = useState()
    const [email, setEmail] = useState()
    const [method, setMethod] = useState('annual')
    const [paymentMethod, setPaymentMethod] = useState('recurring')
    const [channelManager, setChannelManager] = useState()
    const [pms, setPms] = useState()

    const [basic, setBasic] = useState('')

    const [promos, setPromos] = useState([])

    const matches = useMediaQuery('(min-width:600px)')

    const [roiAdr, setRoiAdr] = useState()
    const [roiOcc, setRoiOcc] = useState()
    const [roiRooms, setRoiRooms] = useState()
    

    function isNotClassicAssistant () {
        if (!quote || !quote.quote) return false
        return (quote.quote.product === 'ASSISTANT_LEI' || quote.quote.product === 'ASSISTANT_BUS')
    }


    function isEmailValid(){
        if(email)
            return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(email)
        
        return true
    }

    function isFormValid(){
        if(name && email && isEmailValid() && method && paymentMethod && channelManager && pms){
            return true
        }else{
            return false
        }
    }

    function expiringDate(){
         let dayMs= 86400000
            let dateMs = Date.parse(quote.timestamp)
            let exp = dateMs + (dayMs*quote.expiration)
            return exp;
    }

    function formatDate(){
        if (quote && quote.expiration){
            let exp = expiringDate()
            let lang = i18n.language === 'en' ? 'en-GB':(i18n.language+'-'+i18n.language.toUpperCase())
            return ""+new Date(exp).toLocaleDateString(lang,{ weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
        }
        return ""
    }

    function pdfFileName(){
        let today = Date.now();
        return "lybra_assistant_quote_"+new Date(today).toLocaleDateString('en-GB')
    }

    function isQuoteExpired(){
        if (!quote || !quote.quote || !quote.expiration) return true
        
            let exp = expiringDate()
            let today = Date.now()
            if(today <= exp){
                return false
            }else{
                return true
            }
    }

    useEffect(() => {
        const configRef = ref(database, 'config')
        onValue(configRef, (data) => {
            const snap = data.val()
            if (snap && snap.basic) {
                setBasic(snap.basic)
            }
            if(snap && snap.promo){
                setPromos(snap.promo)
            }
        }, {
            onlyOnce: true
        })

        const quoteRef = ref(database, 'quotes/auth0|' + sales + '/' + id)
        const userRef = ref(database, 'users/auth0|' + sales)
        onValue(quoteRef, (snapshot) => {
            
            if(!snapshot.val().quote.totals){
                setQuote({
                    ...snapshot.val(),
                    quote: {
                        ...snapshot.val().quote,
                        totals: snapshot.val().totals
                    }
                })
            }else{
                setQuote(snapshot.val())
            }
        }, {
            onlyOnce: true
        })

        onValue(userRef, (snapshot) => {
            setUser(snapshot.val())
        }, {
            onlyOnce: true
        
        })       

    }, [])

    function handleAccept () {
        if (!name) {
            alert(t('validation.name'))
            return
        }
        if (!email) {
            alert(t('validation.email'))
            return
        }
        if (!method) {
            alert(t('validation.method'))
            return
        }
        if (!pms) {
            alert(t('validation.pms'))
            return
        }
        if (!channelManager) {
            alert(t('validation.channelManager'))
            return
        }
        const quoteRef = ref(database, 'quotes/auth0|' + sales + '/' + id)
        set(quoteRef, {
            ...quote,
            accepted: {
                timestamp: new Date().toUTCString(),
                name,
                email,
                method,
                paymentMethod,
                pms,
                channelManager
            }
        })

        if(quote && !quote.reseller && !quote.subQuotes){
            alert(t('accepted'))
        }

        refreshQuote()
    }

    function calculateRoi(increase){
        let absRoi = 0
        let percRoi = 0

        if(roiAdr && roiOcc && roiRooms && quote){
            let incAdr = roiAdr * (1+increase/100)
            let annualRev = roiAdr * roiRooms * roiOcc
            let annualRevInc = incAdr*roiRooms*roiOcc
            annualRevInc = annualRevInc-annualRev
            percRoi = Math.round((annualRevInc / quote.totals.annual)*100)
            absRoi = Math.round(annualRevInc - quote.totals.annual)
        }

        return (<div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    paddingTop: '1rem',
                    paddingBottom: '1rem'
                }}>
                    <Typography sx={{ fontSize: 16, fontWeight: 'normal' }}>
                        +{increase}% ADR
                    </Typography>
                    <Typography sx={{ fontSize: 30, fontWeight: 'medium' }}>
                        {absRoi > 0 ? '+':''}{absRoi.toLocaleString()} {currencyMap[quote.quote.currency]}
                    </Typography>
                    <Typography sx={{ fontSize: 16, fontWeight: 'medium' }}>
                        {percRoi.toLocaleString()}%
                    </Typography>
                </div>)
    }

    async function markDeal (quote) {
        const response = await fetch('https://api.lybra.tech/API/pricing/ac/deal', {
            method: 'POST',
            headers: {
                'Authorization': 'Basic ' + basic,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                acOwner: null,
                ...quote,
                additionalMonths: quote.quote.promo && quote.quote.promo !== '' && promos && promos[quote.quote.promo].additionalMonths ? promos[quote.quote.promo].additionalMonths:0,
                promoDescription: quote.quote.promo && quote.quote.promo !== '' && promos && promos[quote.quote.promo].description ? promos[quote.quote.promo].description:""
            })
        })
    }

    function refreshQuote () {
        const quoteRef = ref(database, 'quotes/auth0|' + sales + '/' + id)
        onValue(quoteRef, (snapshot) => {
            const quoteData = snapshot.val()
            setQuote(quoteData)
            markDeal(quoteData)
        }, {
            onlyOnce: true
        })
    }

    function renderQuote (quote) {
        return (
            <Fragment>
                <div style={{
                    maxWidth: '700px',
                    width: '100%',
                    margin: '0 auto',
                    paddingLeft: '1rem',
                    paddingRight: '1rem',
                    marginTop: '2rem',
                    marginBottom: '1rem',
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'start'
                }}>
                    <div>
                        <span style={{
                            display: 'block',
                            color: 'rgba(0,0,0,0.6)',
                            marginBottom: '0.4rem'
                        }}>{t('hotel')}</span>
                        <div style={{
                            fontSize: '1.2rem'
                        }}>
                            {quote.name} ({ t('duration')}: {quote.duration})
                        </div>
                    </div>
                </div>

                <div style={{
                    marginTop: '1rem',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    
                    <div style={{
                        maxWidth: '700px',
                        width: '100%'
                    }}>
                        
                            {
                            quote.product === 'ASSISTANT_LEI' &&
                                <Typography sx={{ fontSize: 30, fontWeight: 'medium', color: '#3cb0a9' }}>
                                   {t('products.leisure')}
                                </Typography>
                            }
                            {
                            quote.product === 'ASSISTANT_BUS' &&
                                <Typography sx={{ fontSize: 30, fontWeight: 'medium', color: '#3cb0a9' }}>
                                   {t('products.business')}
                                </Typography>
                            }
                            {
                            quote.product === 'ASSISTANT' &&
                                <Typography sx={{ fontSize: 30, fontWeight: 'medium', color: '#3cb0a9' }}>
                                   {t('products.forYou')}
                                </Typography>
                            }
                            {
                            quote.product === 'ADVISOR' &&
                                <Typography sx={{ fontSize: 30, fontWeight: 'medium', color: '#3cb0a9' }}>
                                   {t('products.advisor')}
                                </Typography>
                            }
                            

                        <Card style={{ marginTop: '1.5rem' }}>
                            <CardContent>
                                <Typography sx={{ fontSize: 24, fontWeight: 'medium', color: '#3cb0a9' }}>
                                    {t('modules.title')}
                                </Typography>
                            </CardContent>
                            <TableContainer>
                                <Table size={'small'}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>{t('modules.displacementModule')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src={quote.displacement ? '/check.png' : '/cross.png'} />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('modules.financeModule')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src={quote.financial ? '/check.png' : '/cross.png'} />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('modules.flightsModule')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src={quote.flights ? '/check.png' : '/cross.png'} />
                                            </TableCell>
                                        </TableRow>
                                        {quote.country === 'Italy' &&
                                        <TableRow>
                                            <TableCell>{t('modules.eyeModule')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src={quote.eye ? '/check.png' : '/cross.png'} />
                                            </TableCell>
                                        </TableRow>
                                        }
                                        <TableRow>
                                            <TableCell>{t('modules.gapModule')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src={quote.gapAnalysis ? '/check.png' : '/cross.png'} />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('modules.autopilotFunctionality')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src={quote.autopilot ? '/check.png' : '/cross.png'} />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('modules.gridModule')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src={quote.rateGrid ? '/check.png' : '/cross.png'} />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('modules.biModule')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src={quote.bi ? '/check.png' : '/cross.png'} />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('modules.rmsModule')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src={quote.rms ? '/check.png' : '/cross.png'} />
                                            </TableCell>
                                        </TableRow>                                        
                                        <TableRow>
                                            <TableCell>{t('modules.commissionsFunctionality')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src={quote.commission ? '/check.png' : '/cross.png'} />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('modules.rateCheckerModule')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src={quote.rateChecker ? '/check.png' : '/cross.png'} />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('modules.marketingModule')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src='/check.png' />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('modules.rateShopperModule')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src='/check.png' />
                                            </TableCell>
                                        </TableRow>                         
                                        <TableRow>
                                            <TableCell>{t('modules.criFunctionality')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src='/check.png' />
                                            </TableCell>
                                        </TableRow>    
                                        <TableRow>
                                            <TableCell>{t('modules.calendarModule')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src='/check.png' />
                                            </TableCell>
                                        </TableRow> 
                                        <TableRow>
                                            <TableCell>{t('modules.restrictions')}</TableCell>
                                            <TableCell align={'right'}>
                                                <img style={{ height: '15px' }} src={quote.restrictions ? '/check.png' : '/cross.png'} />
                                            </TableCell>
                                        </TableRow>  
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Card>

                        <Card style={{ marginTop: '1.5rem' }}>
                           
                           <CardContent>
                               <Typography sx={{ fontSize: 24, fontWeight: 'medium', color: '#3cb0a9' }}>
                                   {t('integratedRateShopper.title')}
                               </Typography>
                           </CardContent>

                           <TableContainer>
                               <Table size={'small'}>
                                   <TableBody>
                                       <TableRow>
                                           <TableCell>{t('integratedRateShopper.hotel')}</TableCell>
                                           <TableCell align={'right'}>1</TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell>{t('integratedRateShopper.compset')}</TableCell>
                                           <TableCell align={'right'}>{quote.competitor}</TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell>{t('integratedRateShopper.channel')}</TableCell>
                                           <TableCell align={'right'}>1</TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell>{t('integratedRateShopper.roomTypes')}</TableCell>
                                           <TableCell align={'right'}>{quote.roomTypes}</TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell>{t('integratedRateShopper.minLos')}</TableCell>
                                           <TableCell align={'right'}> <img style={{ height: '15px' }} src='/check.png' /></TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell>{t('integratedRateShopper.daysout')}</TableCell>
                                           <TableCell align={'right'}>120</TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell>{t('integratedRateShopper.dailyshop')}</TableCell>
                                           <TableCell align={'right'}>1</TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell>{t('integratedRateShopper.daysoutW')}</TableCell>
                                           <TableCell align={'right'}>365</TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell>{t('integratedRateShopper.weeklyshop')}</TableCell>
                                           <TableCell align={'right'}>1</TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell>{t('integratedRateShopper.daysoutD')}</TableCell>
                                           <TableCell align={'right'}>120</TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell>{t('integratedRateShopper.ondemandShop')}</TableCell>
                                           <TableCell align={'right'}><img style={{ height: '15px' }} src='/check.png' /></TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell>{t('integratedRateShopper.loginUpdate')}</TableCell>
                                           <TableCell align={'right'}><img style={{ height: '15px' }} src='/check.png' /></TableCell>
                                       </TableRow>
                                   </TableBody>
                               </Table>
                           </TableContainer>
                       </Card>

                        {
                            (quote.rateChecker) &&
                            <Card style={{ marginTop: '1.5rem' }}>
                                <CardContent>
                                    <Typography sx={{ fontSize: 24, fontWeight: 'medium', color: '#3cb0a9' }}>
                                        {t('rateChecker.title')}
                                    </Typography>
                                </CardContent>
                                <TableContainer>
                                    <Table size={'small'}>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>{t('rateChecker.properties')}</TableCell>
                                                <TableCell align={'right'}>
                                                    {quote.hotels}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>{t('rateChecker.channels')}</TableCell>
                                                <TableCell align={'right'}>
                                                    {quote.channels}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>{t('rateChecker.los')}</TableCell>
                                                <TableCell align={'right'}>
                                                    {quote.los}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>{t('rateChecker.daysout')}</TableCell>
                                                <TableCell align={'right'}>
                                                    {quote.daysOut}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>{t('rateChecker.dailyShop')}</TableCell>
                                                <TableCell align={'right'}>
                                                    {quote.dailyFrequency}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>{t('rateChecker.daysoutW')}</TableCell>
                                                <TableCell align={'right'}>
                                                    {quote.daysOutW}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>{t('rateChecker.weeklyshop')}</TableCell>
                                                <TableCell align={'right'}>
                                                    {quote.weeklyFrequency}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>
                        }
                        {
                            quote.country === 'Italy' &&
                            <Card style={{ marginTop: '1.5rem' }}>
                                <CardContent>
                                    <Typography sx={{ fontSize: 24, fontWeight: 'medium', color: '#3cb0a9' }}>
                                        {t('services.title')}
                                    </Typography>
                                </CardContent>
                                <TableContainer>
                                    <Table size={'small'}>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>{t('services.consultancy')}</TableCell>
                                                <TableCell align={'right'}>
                                                    <img style={{ height: '15px' }} src={quote.consultancy ? '/check.png' : '/cross.png'} />
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>
                        }
                        {
                            quote.promo && quote.promo !== '' && promos &&
                            <Card style={{ marginTop: '1.5rem' }}>
                                <CardContent>
                                    <Typography sx={{ fontSize: 24, fontWeight: 'medium', color: '#3cb0a9' }}>
                                        {t('promo.title')} {quote.promo}
                                    </Typography>
                                </CardContent>
                                <TableContainer>
                                    <Table size={'small'}>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell align={'center'} colSpan={'2'}>
                                                    {promos[quote.promo].description}
                                                </TableCell>
                                            </TableRow>
                                            {
                                                promos[quote.promo].setupDiscount &&
                                                <TableRow>
                                                    <TableCell>{t('promo.setupDiscount')}</TableCell>
                                                    <TableCell align={'right'}>
                                                        {promos[quote.promo].setupDiscount*100}%
                                                    </TableCell>
                                                </TableRow>
                                            }
                                            {
                                                promos[quote.promo].freeMonth &&
                                                <TableRow>
                                                    <TableCell>{t('promo.extraDiscount')}</TableCell>
                                                    <TableCell align={'right'}>
                                                        {Math.round(quote.totals.month)} {currencyMap[quote.currency]} {quote.properties > 1 && <span>{t('quote.single')}</span>}
                                                        <Typography sx={{ fontSize: 12, color: 'gray', whiteSpace: 'pre-line' }}>{t('promo.freeMonth')}</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            }
                                            {
                                                promos[quote.promo].additionalMonths &&
                                                <TableRow>
                                                    <TableCell>{t('promo.additionalMonths')}</TableCell>
                                                    <TableCell align={'right'}>
                                                        {promos[quote.promo].additionalMonths}
                                                    </TableCell>
                                                </TableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>
                        }
                    </div>
                </div>
                <div style={{
                    marginTop: '2rem',
                    textAlign: 'center',
                    color: '#3cb0a9',
                    fontSize: '30px'
                }}>
                    {t('quote.pricing')}
                </div>
                {
                        quote.properties > 1 && 
                        <div style={{
                            marginTop: '0.1rem',
                            marginBottom: '0.5rem',
                            textAlign: 'center',
                            fontSize: '14px'
                        }}>{t('quote.single')}</div>
                }
                <div style={{
                    marginTop: '1.1rem',
                    marginBottom: '1.5rem',
                    textAlign: 'center',
                    fontSize: '20px'
                }}>
                    {t('setupFee')} {quote.totals.setup.toFixed(0)} 
                    {currencyMap[quote.currency]} {(quote.totals.originSetup > quote.totals.setup) && <span style={{ fontSize: 16, textDecoration: 'line-through'}}> {quote.totals.originSetup}{currencyMap[quote.currency]}</span>}
                    {currencyMap[quote.currency]} {(quote.totals.originSetup === 0) && <span style={{ fontSize: 16, textDecoration: 'line-through'}}> {(quote.totals.setup/0.8).toFixed(0)}{currencyMap[quote.currency]}</span>}
                </div>
                <div style={{
                    marginTop: '1rem',
                    maxWidth: '700px',
                    width: '100%',
                    margin: '0 auto',
                    backgroundColor: '#94e0dc',
                    color: '#1a524e',
                    borderRadius: '20px',
                }}>
                    <Grid container>
                        <Grid xs={12} sm={4} spacing={2} style={{ alignItems: 'center'}}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                paddingTop: '1rem',
                                paddingBottom: '1rem'
                            }}>
                                <Typography sx={{ fontSize: 16, fontWeight: 'normal' }}>
                                    {t('monthly')}
                                </Typography>
                                <Typography sx={{ fontSize: 30, fontWeight: 'medium' }}>
                                    {
                                        (quote.totals.originMonth > quote.totals.month) &&
                                        <div style={{
                                            textAlign: 'center',
                                            fontSize: 16,
                                            textDecoration: 'line-through'
                                        }}>
                                            {Math.round(quote.totals.originMonth)} {currencyMap[quote.currency]}
                                        </div>
                                    }
                                    {
                                        (quote.totals.originMonth === 0 || quote.totals.originMonth < quote.totals.month) &&
                                        <div style={{
                                            textAlign: 'center',
                                            fontSize: 16,
                                            textDecoration: 'line-through'
                                        }}>
                                            {Math.round(quote.totals.month/0.9)} {currencyMap[quote.currency]}
                                        </div>
                                    }
                                    {Math.round(quote.totals.month)} {currencyMap[quote.currency]}
                                </Typography>
                                <Typography sx={{ fontSize: 16, fontWeight: 'medium' }}>
                                    {t('monthly')}
                                </Typography>
                            </div>
                        </Grid>

                        <Grid xs={12} sm={4} spacing={2} style={{ alignItems: 'center'}}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                paddingTop: '1rem',
                                paddingBottom: '1rem'
                            }}>
                                <Typography sx={{ fontSize: 16, fontWeight: 'normal' }}>
                                    {t('semester')}
                                </Typography>
                                <Typography sx={{ fontSize: 30, fontWeight: 'medium' }}>
                                    {
                                        (quote.totals.originSemester > quote.totals.semester) &&
                                        <div style={{
                                            textAlign: 'center',
                                            fontSize: 16,
                                            textDecoration: 'line-through'
                                        }}>
                                            {Math.round(quote.totals.originSemester)} {currencyMap[quote.currency]}
                                        </div>
                                    }
                                    {
                                        (quote.totals.originSemester === 0 || quote.totals.originSemester < quote.totals.semester) &&
                                        <div style={{
                                            textAlign: 'center',
                                            fontSize: 16,
                                            textDecoration: 'line-through'
                                        }}>
                                            {Math.round(quote.totals.semester/0.9)} {currencyMap[quote.currency]}
                                        </div>
                                    }
                                    {Math.round(quote.totals.semester)} {currencyMap[quote.currency]}
                                </Typography>
                                <Typography sx={{ fontSize: 16, fontWeight: 'medium' }}>
                                    {t('semester')}
                                </Typography>
                            </div>
                        </Grid>

                        <Grid xs={12} sm={4} spacing={2} style={{ alignItems: 'center'}}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                paddingTop: '1rem',
                                paddingBottom: '1rem'
                            }}>
                                <Typography sx={{ fontSize: 16, fontWeight: 'normal' }}>
                                    {t('year')}
                                </Typography>
                                <Typography sx={{ fontSize: 30, fontWeight: 'medium' }}>
                                    {
                                        (quote.totals.originAnnual > quote.totals.annual) &&
                                        <div style={{
                                            textAlign: 'center',
                                            fontSize: 16,
                                            textDecoration: 'line-through'
                                        }}>
                                            {Math.round(quote.totals.originAnnual)} {currencyMap[quote.currency]}
                                        </div>
                                    }
                                    {
                                        (quote.totals.originAnnual === 0 || quote.totals.originAnnual < quote.totals.annual) &&
                                        <div style={{
                                            textAlign: 'center',
                                            fontSize: 16,
                                            textDecoration: 'line-through'
                                        }}>
                                            {Math.round(quote.totals.annual/0.9)} {currencyMap[quote.currency]}
                                        </div>
                                    }
                                    {Math.round(quote.totals.annual)} {currencyMap[quote.currency]}
                                </Typography>
                                <Typography sx={{ fontSize: 16, fontWeight: 'medium' }}>
                                    {t('year')}
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                { (quote.properties > 1) &&
                    <div>
                        <div style={{
                            marginTop: '2rem',
                            textAlign: 'center',
                            color: '#3cb0a9',
                            fontSize: '30px'
                        }}>
                            {t('quote.total')}
                        </div>
                        <div style={{
                            marginTop: '0.1rem',
                            marginBottom: '0.5rem',
                            textAlign: 'center',
                            fontSize: '14px'
                        }}>{quote.properties} {t('quote.properties')}</div>
                        <div style={{
                            marginTop: '1.1rem',
                            marginBottom: '1.5rem',
                            textAlign: 'center',
                            fontSize: '20px'
                        }}>
                            {t('setupFee')} {quote.totals.setup.toFixed(0)*quote.properties} {currencyMap[quote.currency]} {(quote.totals.originSetup > quote.totals.setup) && <span style={{ fontSize: 16, textDecoration: 'line-through'}}> {quote.totals.originSetup*quote.properties}{currencyMap[quote.currency]}</span>}
                        </div>
                        <div style={{
                            marginTop: '1rem',
                            maxWidth: '700px',
                            width: '100%',
                            margin: '0 auto',
                            backgroundColor: '#94e0dc',
                            color: '#1a524e',
                            borderRadius: '20px',
                        }}>
                            <Grid container>
                                <Grid xs={12} sm={4} spacing={2} style={{ alignItems: 'center'}}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        paddingTop: '1rem',
                                        paddingBottom: '1rem'
                                    }}>
                                        <Typography sx={{ fontSize: 16, fontWeight: 'normal' }}>
                                            {t('monthly')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 30, fontWeight: 'medium' }}>
                                            {
                                                (quote.totals.originMonth > quote.totals.month) &&
                                                <div style={{
                                                    textAlign: 'center',
                                                    fontSize: 16,
                                                    textDecoration: 'line-through'
                                                }}>
                                                    {Math.round(quote.totals.originMonth)*quote.properties} {currencyMap[quote.currency]}
                                                </div>
                                            }
                                            {
                                                (quote.totals.originMonth === 0) &&
                                                <div style={{
                                                    textAlign: 'center',
                                                    fontSize: 16,
                                                    textDecoration: 'line-through'
                                                }}>
                                                    {Math.round(quote.totals.month/0.9)*quote.properties} {currencyMap[quote.currency]}
                                                </div>
                                            }
                                            {Math.round(quote.totals.month)*quote.properties} {currencyMap[quote.currency]}
                                        </Typography>
                                        <Typography sx={{ fontSize: 16, fontWeight: 'medium' }}>
                                            {t('monthly')}
                                        </Typography>
                                    </div>
                                </Grid>

                                <Grid xs={12} sm={4} spacing={2} style={{ alignItems: 'center'}}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        paddingTop: '1rem',
                                        paddingBottom: '1rem'
                                    }}>
                                        <Typography sx={{ fontSize: 16, fontWeight: 'normal' }}>
                                            {t('semester')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 30, fontWeight: 'medium' }}>
                                            {
                                                (quote.totals.originSemester > quote.totals.semester) &&
                                                <div style={{
                                                    textAlign: 'center',
                                                    fontSize: 16,
                                                    textDecoration: 'line-through'
                                                }}>
                                                    {Math.round(quote.totals.originSemester)*quote.properties} {currencyMap[quote.currency]}
                                                </div>
                                            }
                                            {
                                                (quote.totals.originSemester === 0) &&
                                                <div style={{
                                                    textAlign: 'center',
                                                    fontSize: 16,
                                                    textDecoration: 'line-through'
                                                }}>
                                                    {Math.round(quote.totals.semester/0.9)*quote.properties} {currencyMap[quote.currency]}
                                                </div>
                                            }
                                            {Math.round(quote.totals.semester)*quote.properties} {currencyMap[quote.currency]}
                                        </Typography>
                                        <Typography sx={{ fontSize: 16, fontWeight: 'medium' }}>
                                            {t('semester')}
                                        </Typography>
                                    </div>
                                </Grid>

                                <Grid xs={12} sm={4} spacing={2} style={{ alignItems: 'center'}}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        paddingTop: '1rem',
                                        paddingBottom: '1rem'
                                    }}>
                                        <Typography sx={{ fontSize: 16, fontWeight: 'normal' }}>
                                            {t('year')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 30, fontWeight: 'medium' }}>
                                            {
                                                (quote.totals.originAnnual > quote.totals.annual) &&
                                                <div style={{
                                                    textAlign: 'center',
                                                    fontSize: 16,
                                                    textDecoration: 'line-through'
                                                }}>
                                                    {Math.round(quote.totals.originAnnual*quote.properties)} {currencyMap[quote.currency]}
                                                </div>
                                            }
                                            {
                                                (quote.totals.originAnnual === 0) &&
                                                <div style={{
                                                    textAlign: 'center',
                                                    fontSize: 16,
                                                    textDecoration: 'line-through'
                                                }}>
                                                    {Math.round((quote.totals.annual*quote.properties)/0.9)} {currencyMap[quote.currency]}
                                                </div>
                                            }
                                            {Math.round(quote.totals.annual*quote.properties)} {currencyMap[quote.currency]}
                                        </Typography>
                                        <Typography sx={{ fontSize: 16, fontWeight: 'medium' }}>
                                            {t('year')}
                                        </Typography>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                }
                <div style={{
                    marginTop: '0.3rem',
                    color: 'rgba(0,0,0,0.6)',
                    textAlign: 'center',
                    fontSize: '14px'
                }}>
                    <div>
                        {t('excludedVat')}
                    </div>
                </div>
                <div style={{
                    marginTop: '0.3rem',
                    marginBottom: '1.5rem',
                    color: 'rgba(0,0,0,0.6)',
                    textAlign: 'center',
                    fontSize: '14px'
                }}>
                    <div>
                        {t('excludedCostsPms')}
                    </div>
                </div>
            </Fragment>
        )
    }

    useEffect(() => {
        if (quote && quote.quote && quote.quote.country === 'ITALY') {
            i18n.changeLanguage('it')
        } else {
            i18n.changeLanguage('en')
        }
    }, [ quote ])

    return (
        <div style={{
            background: '#FFF',
            paddingTop: '1rem',
            paddingLeft: '1rem',
            paddingRight: '1rem',
            paddingBottom: '6rem'
        }}>
            <img src={'/bgtop.jpg'} style={{
                position: 'fixed',
                top: 0,
                left: 0,
                height: matches ? 200 : 100,
                zIndex: 1
            }} />

            <img src={'/bgbottom.jpg'} style={{
                position: 'fixed',
                bottom: 0,
                right: 0,
                height: matches ? 200 : 100,
                zIndex: 1
            }} />
            {
                (quote && user) &&
                    <div style={{
                        position: 'relative',
                        zIndex: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            paddingLeft: '1rem',
                            paddingRight: '1rem',
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '1rem',
                            justifyContent: 'center'
                        }}>
                        <img
                            style={{ width: '100px', width: 'auto' }}
                            src="https://lybra.tech/wp-content/uploads/2021/04/logopositivo.png" />
                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <img 
                                onClick={() => {
                                    i18n.changeLanguage('it')
                                }}
                                style={{ cursor: 'pointer', height: 30 }} src="https://img.icons8.com/color/48/000000/italy.png"/>
                            <img 
                                onClick={() => {
                                    i18n.changeLanguage('en')
                                }}
                                style={{ cursor: 'pointer', height: 30, marginLeft: 10 }} src="https://img.icons8.com/color/48/000000/great-britain.png"/>
                            <img 
                                onClick={() => {
                                    i18n.changeLanguage('es')
                                }}
                                style={{ cursor: 'pointer', height: 30, marginLeft: 10 }} src="https://img.icons8.com/color/48/000000/spain.png"/>
                            <img 
                                onClick={() => {
                                    i18n.changeLanguage('de')
                                }}
                                style={{ cursor: 'pointer', height: 30, marginLeft: 10 }} src="https://img.icons8.com/color/48/000000/germany.png"/>
                        </div>

                        {
                            (quote && user) &&
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                                <PDFDownloadLink fileName={pdfFileName()}
                                    document={<Quote user={user} quote={quote.quote} expiration={formatDate()} promos={promos}></Quote>}>
                                    <Button
                                        startIcon={<DownloadIcon />}>
                                        {t('download')} PDF
                                    </Button>
                                </PDFDownloadLink>
                            </div>
                        }

                        <div style={{
                            maxWidth: '700px',
                            width: '100%',
                            margin: '0 auto',
                            paddingLeft: '1rem',
                            boxSizing: 'border-box',
                            paddingRight: '1rem',
                            marginTop: '2rem',
                            display: 'flex',
                            justifyContent: 'end'
                        }}>
                            <div style={{
                                textAlign: 'right'
                            }}>
                                <span style={{
                                    display: 'block',
                                    marginBottom: '0.4rem',
                                    color: 'rgba(0,0,0,0.6)'
                                }}>{t('customer')}</span>
                                <div style={{
                                    fontSize: '1.2rem'
                                }}>
                                    {user.name}
                                </div>
                                <div style={{
                                    marginTop: '0.2rem',
                                    color: 'rgba(0,0,0,0.6)'
                                }}>
                                    {user.email}
                                </div>
                                {quote.expiration &&
                                    <div style={{
                                        marginTop: '0.2rem',
                                        color: 'rgba(0,0,0,0.6)'
                                    }}>
                                    {t('expiringdate')} <strong>{formatDate()}</strong>
                                    </div>
                                }
                            </div>
                        </div>

                        {renderQuote(quote.quote)}

                        {
                            (quote && quote.quote && quote.quote.subQuotes) &&
                            quote.quote.subQuotes.map(subQuote => renderQuote(subQuote))
                        }
                           
                        {
                            (!quote.accepted) ?
                                (!isQuoteExpired() ? 
                                    <div>
                                        <Fragment>
                                            <div style={{
                                                marginTop: '2.5rem',
                                                textAlign: 'center',
                                                color: '#3cb0a9',
                                                fontSize: '30px'
                                            }}>
                                                {t("yourData")}
                                            </div>
                    
                                            <div style={{ textAlign: 'center', color: 'rgba(0,0,0,0.7)', paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '0.5rem'}}>
                                                {t("quoteAcceptanceForm")}
                                            </div>
                    
                                            <div style={{
                                                maxWidth: '700px',
                                                width: '100%',
                                                margin: '0 auto',
                                                dispaly: 'flex',
                                                flexDirection: 'column'
                                            }}>
                                                <Grid container spacing={4} style={{ marginTop: '0.5rem' }}>
                    
                                                    <Grid item xs={12} sm={6}>
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                label={t("nominative")}
                                                                onChange={(event) => {
                                                                    setName(event.target.value)
                                                                }}
                                                                value={name}
                                                                fullWidth  />
                                                        </FormControl>
                                                    </Grid>
                    
                                                    <Grid item xs={12} sm={6} position={'relative'}>
                                                        {
                                                            email &&
                                                                <img style={{ height: '15px', position: 'absolute', top: '50px', right: '10px' }} src={isEmailValid() ? '/check.png':'/cross.png'} />
                                                        }
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                onChange={(event) => {
                                                                    setEmail(event.target.value.trim())
                                                                }}
                                                                value={email}
                                                                fullWidth label={t("email")} />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                        <FormControl fullWidth>
                                                            <InputLabel>{t("billingPeriod")}</InputLabel>
                                                            <Select
                                                                labelId="fee"
                                                                id="fee"
                                                                fullWidth
                                                                label={t("billingPeriod")}
                                                                onChange={(event) => {
                                                                    setMethod(event.target.value)
                                                                    if(event.target.value !== 'annual'){
                                                                        setPaymentMethod('recurring')
                                                                    }
                                                                }}
                                                                value={method}>
                                                                <MenuItem value={'monthly'}>{t("paymentMethodMonth")}</MenuItem>
                                                                <MenuItem value={'semester'}>{t("paymentMethodBiannual")}</MenuItem>
                                                                <MenuItem value={'annual'}>{t("paymentMethodAnnual")}</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} sm={8}>
                                                        <FormControl fullWidth>
                                                            <InputLabel>{t("paymentMethod")}</InputLabel>
                                                            <Select
                                                                disabled = {method !== 'annual'}
                                                                labelId="fee"
                                                                id="fee"
                                                                fullWidth
                                                                label={t("paymentMethod")}
                                                                onChange={(event) => {
                                                                    setPaymentMethod(event.target.value)
                                                                }}
                                                                value={paymentMethod}>
                                                                <MenuItem value={'recurring'}>{t("recurring")}</MenuItem>
                                                                <MenuItem value={'wire'}>{t("wireTransfer")}</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <FormControl fullWidth>
                                                            <Autocomplete
                                                                labelId="channelManager"
                                                                id="channelManager"
                                                                fullWidth
                                                                label={'Channel Manager'}
                                                                onChange={(event, value) => {
                                                                    setChannelManager(value)
                                                                }}
                                                                options={[
                                                                    "Bedzzle",
                                                                    "Blastness",
                                                                    "Book Assist",
                                                                    "Booking Expert",
                                                                    "Ericsoft",
                                                                    "Ermes hotels",
                                                                    "Figaro",
                                                                    "Host",
                                                                    "HotelAvailabilities",
                                                                    "LeoRevoo",
                                                                    "Mews",
                                                                    "MisterBooking",
                                                                    "Octorate Cm",
                                                                    "Opera",
                                                                    "Parity Rate",
                                                                    "PrimalRes",
                                                                    "Protel",
                                                                    "Room Cloud",
                                                                    "Scrigno",
                                                                    "Simple Booking",
                                                                    "SiteMinder",
                                                                    "Slope",
                                                                    "VerticalBooking",
                                                                    "YieldPlanet",
                                                                    "Other CM"
                                                                ]}
                                                                renderInput={(params) => <TextField {...params} label="Channel Manager"></TextField>}
                                                                value={channelManager}>
                                                            </Autocomplete>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <FormControl fullWidth>
                                                            <Autocomplete
                                                                renderInput={(params) => <TextField {...params} label="PMS"></TextField>}
                                                                labelId="bookingEngine"
                                                                id="bookingEngine"
                                                                fullWidth
                                                                label={'PMS'}
                                                                onChange={(event, value) => {
                                                                    setPms(value)
                                                                }}
                                                                value={pms}
                                                                options={[
                                                                    "ACIGrup",
                                                                    "Alyante",
                                                                    "Antfor Software (Avalon)",
                                                                    "Astro Hotel PMS",
                                                                    "Beddy",
                                                                    "Bedzzle",
                                                                    "Chapp Solutions (Lean Hotel System)",
                                                                    "Class One",
                                                                    "Clock PMS",
                                                                    "Cover Pms",
                                                                    "Direct Holiday",
                                                                    "DNR",
                                                                    "Dylog",
                                                                    "Edelweiss",
                                                                    "Engisoft",
                                                                    "Ericsoft",
                                                                    "ErmesHotels",
                                                                    "Fidelio",
                                                                    "Galaxy",
                                                                    "GuestPro",
                                                                    "Host Hotel System",
                                                                    "Hotel 5 Stelle",
                                                                    "Hotel Cube",
                                                                    "Hotel2000",
                                                                    "Hoteliga",
                                                                    "Hotelist",
                                                                    "Hotelogix",
                                                                    "Hotel Runner",
                                                                    "Hoteltec",
                                                                    "IHotelligence",
                                                                    "Leonardo",
                                                                    "Little Hotelier",
                                                                    "MasterYield",
                                                                    "Mews",
                                                                    "MHospitality",
                                                                    "Millenium Soft",
                                                                    "Misterbooking",
                                                                    "MyGuestCare",
                                                                    "Nuconga",
                                                                    "Octorate",
                                                                    "Ofimatica (OfiHotel)",
                                                                    "Opera",
                                                                    "Orange Pms",
                                                                    "Passepartout",
                                                                    "Prestige PMS",
                                                                    "Protel",
                                                                    "Pylon",
                                                                    "Quonext (QuoHotel)",
                                                                    "Scrigno",
                                                                    "Slope",
                                                                    "Sysdat",
                                                                    "The Booking Factory",
                                                                    "Theova - Hotelware PMS",
                                                                    "Timón Hotel PMS",
                                                                    "TMS by Indra",
                                                                    "Ulyses",
                                                                    "WebHotel",
                                                                    "Welcome PMS (Netera)",
                                                                    "Zeus",
                                                                    "Other PMS"
                                                                ]}>
                                                            </Autocomplete>
                                                        </FormControl>
                                                    </Grid>
                    
                                                </Grid>
                                                <div style={{ marginTop: '1rem' }}>
                                                    <Button
                                                        onClick={handleAccept}
                                                        disabled={!isFormValid()}
                                                        variant={'contained'}
                                                        style={{ fontSize: '18px', width: '100%', marginTop: '5px' }}>
                                                        {t("acceptQuote")}
                                                    </Button>
                                                </div>
                                            </div>
                                        </Fragment>
                                        
                                        <Fragment>
                                            <div style={{
                                                marginTop: '2.5rem',
                                                textAlign: 'center',
                                                color: '#3cb0a9',
                                                fontSize: '30px'
                                            }}>
                                                {t("roi.title")}
                                            </div>
                    
                                            <div style={{ textAlign: 'center', color: 'rgba(0,0,0,0.7)', paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '0.5rem'}}>
                                            {t("roi.subtitle")}
                                            </div>
                    
                                            <div style={{
                                                maxWidth: '700px',
                                                width: '100%',
                                                margin: '0 auto',
                                                dispaly: 'flex',
                                                flexDirection: 'column'
                                            }}>
                                                <Grid container spacing={4} style={{ marginTop: '0.5rem' }}>
                                                    <Grid item xs={12} sm={4}>
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                label={t("roi.rooms")}
                                                                onChange={(event) => {
                                                                    setRoiRooms(event.target.value)
                                                                }}
                                                                value={roiRooms}
                                                                fullWidth  />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                label={t("roi.adr")}
                                                                onChange={(event) => {
                                                                    setRoiAdr(event.target.value)
                                                                }}
                                                                value={roiAdr}
                                                                fullWidth  />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                label={t("roi.occ")}
                                                                onChange={(event) => {
                                                                    setRoiOcc(event.target.value)
                                                                    console.log('Occ', event.target.value)
                                                                }}
                                                                value={roiOcc}
                                                                fullWidth  />
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                            </div>

                                            <div style={{
                                                maxWidth: '700px',
                                                width: '100%',
                                                margin: '0 auto',
                                                marginTop: '1rem',
                                                backgroundColor: '#94e0dc',
                                                color: '#1a524e',
                                                borderRadius: '20px',
                                            }}>
                                                <Grid container>
                                                    <Grid xs={12} sm={4} spacing={2} style={{ alignItems: 'center'}}>
                                                        {calculateRoi(0.5)}
                                                    </Grid>

                                                    <Grid xs={12} sm={4} spacing={2} style={{ alignItems: 'center'}}>
                                                        {calculateRoi(7)}
                                                    </Grid>

                                                    <Grid xs={12} sm={4} spacing={2} style={{ alignItems: 'center'}}>
                                                        {calculateRoi(20)}
                                                    </Grid>
                                                </Grid>
                                            </div>

                                        </Fragment>
                                    </div>
                                :
                                <Fragment>
                                    <div style={{
                                    backgroundColor: 'rgb(213, 103, 103)',
                                    color: '#FFF',
                                    maxWidth: '700px',
                                    width: '100%',
                                    margin: '1.5rem auto',
                                    borderRadius: '20px',
                                    paddingTop: '2rem',
                                    paddingBottom: '2rem'
                                    }}>
                                        <div style={{
                                            textAlign: 'center',
                                            fontSize: '30px',
                                            marginBottom: '0.6rem'
                                        }}>
                                            {t('expired')}
                                        </div>
                                        <div style={{
                                            textAlign: 'center'
                                        }}>
                                            {t('expiredon')} <strong>{formatDate()}</strong>
                                        </div>
                                    </div>
                                </Fragment>)
                            :
                            <Fragment>
                                <div style={{
                                    backgroundColor: 'rgb(32,159,63)',
                                    color: '#FFF',
                                    maxWidth: '700px',
                                    width: '100%',
                                    margin: '1.5rem auto',
                                    borderRadius: '20px',
                                    paddingTop: '2rem',
                                    paddingBottom: '2rem'
                                }}>
                                    <div style={{
                                        textAlign: 'center',
                                        fontSize: '30px',
                                        marginBottom: '0.6rem'
                                    }}>
                                        {t('quoteAccepted')}
                                    </div>
                                    <div style={{
                                        textAlign: 'center'
                                    }}>
                                        {t('quoteAcceptedOn')} {quote.accepted.timestamp}
                                    </div>
                                </div>
                            </Fragment>
                        }

                        <div style={{
                            maxWidth: '700px',
                            width: '100%',
                            margin: '0 auto',
                            paddingLeft: '1rem',
                            boxSizing: 'border-box',
                            paddingRight: '1rem',
                            marginTop: '2rem'
                        }}>
                            <div style={{
                               textAlign: 'center',
                               alignItems: 'center',
                               width: '100%'
                            }}>
                                <img
                                    style={{ width: '250px', height: 'auto' }}
                                    src="/assistant.png" />
                            </div>
                            <div style={{
                            }}>
                                <div style={{
                                    
                                }}>
                                    <p>{t('descriptions.lybra')}</p>
                                    <p style={{color: '#3cb0a9',fontWeight: 'bold'}}>{t('descriptions.keyPoints.title')}</p>
                                    <ul>
                                        <li>{t('descriptions.keyPoints.key1')}</li>
                                        <li>{t('descriptions.keyPoints.key2')}</li>
                                        <li>{t('descriptions.keyPoints.key3')}</li>
                                    </ul>

                                    <h2 style={{color: '#3cb0a9', textAlign: 'center'}}>{t('modules.title')}</h2>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.displacementModule')}</strong>: {t('descriptions.modules.displacementModule')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.financeModule')}</strong>: {t('descriptions.modules.financeModule')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.flightsModule')}</strong>: {t('descriptions.modules.flightsModule')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.eyeModule')}</strong>: {t('descriptions.modules.eyeModule')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.gapModule')}</strong>: {t('descriptions.modules.gapModule')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.autopilotFunctionality')}</strong>: {t('descriptions.modules.autopilotFunctionality')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.gridModule')}</strong>: {t('descriptions.modules.gridModule')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.biModule')}</strong>: {t('descriptions.modules.biModule')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.rmsModule')}</strong>: {t('descriptions.modules.rmsModule')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.commissionsFunctionality')}</strong>: {t('descriptions.modules.commissionsFunctionality')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.rateCheckerModule')}</strong>: {t('descriptions.modules.rateCheckerModule')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.marketingModule')}</strong>: {t('descriptions.modules.marketingModule.intro')}
                                        <ul>
                                            <li>{t('descriptions.modules.marketingModule.el1')}</li>
                                            <li>{t('descriptions.modules.marketingModule.el2')}</li>
                                            <li>{t('descriptions.modules.marketingModule.el3')}</li>
                                            <li>{t('descriptions.modules.marketingModule.el4')}</li>
                                            <li>{t('descriptions.modules.marketingModule.el5')}</li>
                                            <li>{t('descriptions.modules.marketingModule.el6')}</li>
                                        </ul>
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.rateShopperModule')}</strong>: {t('descriptions.modules.rateShopperModule')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.criFunctionality')}</strong>: {t('descriptions.modules.criFunctionality')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.calendarModule')}</strong>: {t('descriptions.modules.calendarModule')}
                                    </p>
                                    <p style={{marginBottom: '1rem'}}>
                                        <strong style={{color: '#3cb0a9'}}>{t('modules.restrictions')}</strong>: {t('descriptions.modules.restrictions')}
                                    </p>
                                </div>
                                
                            </div>
                        </div>
                    </div>
            }
        </div>
    )

}